/**
 * @generated SignedSource<<c64959d36101044e5356e3e4633fb833>>
 * @relayHash a7425d19ef032663aa6e5d0bb6c895d6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/TransactionUpdateVatReverseChargeReviewMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TransactionUpdateVatReverseChargeReviewInput = {
  clientMutationId?: string | null;
  isChecked: boolean;
  transactionId: string;
};
export type TransactionUpdateVatReverseChargeReviewMutation$variables = {
  input: TransactionUpdateVatReverseChargeReviewInput;
};
export type TransactionUpdateVatReverseChargeReviewMutation$data = {
  readonly transactionUpdateVatReverseChargeReview: {
    readonly transaction: {
      readonly reviews: ReadonlyArray<{
        readonly status: string | null;
        readonly type: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type TransactionUpdateVatReverseChargeReviewMutation = {
  response: TransactionUpdateVatReverseChargeReviewMutation$data;
  variables: TransactionUpdateVatReverseChargeReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionUpdateVatReverseChargeReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionUpdateVatReverseChargeReviewPayload",
        "kind": "LinkedField",
        "name": "transactionUpdateVatReverseChargeReview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionReview",
                "kind": "LinkedField",
                "name": "reviews",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionUpdateVatReverseChargeReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionUpdateVatReverseChargeReviewPayload",
        "kind": "LinkedField",
        "name": "transactionUpdateVatReverseChargeReview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionReview",
                "kind": "LinkedField",
                "name": "reviews",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/TransactionUpdateVatReverseChargeReviewMutation",
    "metadata": {},
    "name": "TransactionUpdateVatReverseChargeReviewMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "46665394053ae8fde60f26b11f49723c";

export default node;
